import React, { useState } from 'react';
import CheckTwoToneIcon from '@mui/icons-material/CheckTwoTone';
import { useSelector } from 'react-redux';

export default function CopyButton(props) {
    const { copyValue, type = 'icon' } = props;
    const [isCopied, setIsCopied] = useState(false);
    const imageBaseUrl = useSelector(state => state.config.image_base_url);

    function copy() {
        navigator.clipboard.writeText(copyValue);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 1000);
    }

    return (
        <>
            {type === 'icon' && (
                <button type="button" onClick={copy}>
                    {!isCopied ? (
                        <>
                            <img
                                src={`${imageBaseUrl}/copy-icon-green.png`}
                                alt="copyIcon"
                                className="copy-icon"
                            />
                        </>
                    ) : (
                        <>
                            <CheckTwoToneIcon className="dark:invert" />
                        </>
                    )}
                </button>
            )}

            {type === 'button' && (
                <div
                    onClick={copy}
                    className="px-1.5 ml-1 py-1 !bg-secondary rounded flex justify-center items-center cursor-pointer transition-colors duration-200">
                    <div
                        className={`text-xs font-semibold uppercase tracking-[2%] ${
                            isCopied ? '!text-widget' : '!text-text'
                        }`}>
                        {isCopied ? 'Copied' : 'Copy'}
                    </div>
                </div>
            )}
        </>
    );
}
